<template>
  <div class="main">
    <CoolLightBox :items="photos" :index="index" loop @close="index = null">
    </CoolLightBox>
    <div class="gallery-section">
      <div class="section">
        <h2 class="tableTitle">Upload Image :</h2>
        <button @click="pickFile" class="admin-btn">Upload image</button>
        <input
          type="file"
          ref="fileInput"
          style="display: none"
          accept="image/*"
          @change="filePicked"
        />
      </div>
      <div class="line"></div>
      <div class="section">
        <h2 class="tableTitle">My Images :</h2>
        <div class="images">
        <carousel
              v-if="!isLoading"
              class="gallery_active owl-carousel owl-loaded owl-drag"
              :items="myOptions.items"
              :navText="myOptions.navText"
              :autoplaySpeed="myOptions.autoplaySpeed"
              :nav="myOptions.nav"
              :autoplayHoverPause="myOptions.autoplayHoverPause"
              :autoplay="myOptions.autoplay"
              :dots="myOptions.dots"
              :margin="myOptions.margin"
              :responsive="myOptions.responsive"
              :loop="myOptions.loop"
            >
              <div
                class="single_gallery"
                v-for="(image, imageIndex) in photos"
                :key="imageIndex"
              >
                <div class="thumb">
                  <img :src="image.src" alt="Barbershop Agadir | salon de coiffure Agadir | صالون حلاقة" />
                  <div class="image_hover">
                    <a class="popup-image">
                      <i @click="index = imageIndex" class="show"></i>
                      <i @click="deleteImage(image,imageIndex)" class="remove"></i>
                    </a>
                  </div>
                </div>
              </div>
            </carousel>
      </div>

      </div>
    
    </div>
  


  </div>
</template>

<script>
import { fb,db } from "../../store/firebase";
import carousel from "vue-owl-carousel";
import CoolLightBox from "vue-cool-lightbox";

const documnetPath = 'barbersImage/forms';
export default {
    components: { carousel, CoolLightBox },

  data() {
    return {
       myOptions: {
        loop: true,
        nav: true,
        dots: false,
        margin: 30,
        items: 5,
        autoplay: true,
        navText: [
          '<i class="ti-angle-left"></i>',
          '<i class="ti-angle-right"></i>',
        ],
        autoplayHoverPause: true,
        autoplaySpeed: true,
        responsive: {
          0: {
            items: 1,
            nav: true,
          },
          767: {
            items: 4,
            nav: true,
          },
          992: {
            items: 6,
            nav: true,
          },
        },
      },
    barbers:{},
    photos:[],
    isLoading:false,
    index: null,
    };
  },
    firestore() {
		return {
			firebaseData: db.doc(documnetPath),
		};
	},
  methods: {
    pickFile() {
      this.$refs.fileInput.click();
    },

    deleteImage(img,index){
    if(confirm('Are you sure ?')){
      let image = fb.storage().refFromURL(img.src);
      this.photos.splice(index,1);
      image.delete().then(function() {
        db.collection('barbersImage').doc(img.id).delete().then(function(){
        console.log('You deleted it ');
      }).catch(function(error){
        console.log('You get an error : ',error);
      });
       
      }).catch(function(error) {
        // Uh-oh, an error occurred!
        console.log(error,'an error occurred');
      });
    }
     this.fetchImages();

     
    },

    // Pick an Image & upload it to firebase & get,store the url to array
   async filePicked(e) {
            if(e.target.files[0]){
        
          let file = e.target.files[0];
    
          var storageRef = fb.storage().ref('barbers/'+ Math.random() + '_'  + file.name);
              
          let uploadTask  = storageRef.put(file);
    
          await uploadTask.on('state_changed', () => {
          
            
          }, (error) => {
            console.log(error)
          }, (snapshot) => {
            console.log(snapshot);
            console.log(uploadTask.snapshot.ref.getDownloadURL())
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              this.barbers.id=Math.random().toString(36).substring(7);
              this.barbers.src=downloadURL;
                console.log('File available at', this.barbers);
                try{
                db.collection('barbersImage').doc(this.barbers.id).set(this.barbers);
                console.log('this should be the last one :',this.barbers)
                this.state = 'synced';
                } catch (error) {
                console.log(error);
                this.state = 'error';
               }
                this.photos=[];
                this.fetchImages();
              
            });
          });
        
          
          
      }
       
     
    },
     fetchImages() {
       this.isLoading=true;
      db.collection("barbersImage")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
         if(doc.data().src !== undefined){
          this.photos.push(doc.data());
          this.isLoading=false;

         }
        });
      });
      

  }
  },

   created() {
     this.isLoading=true;
    db.collection("barbersImage")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
         if(doc.data().src !== undefined){
          this.photos.push(doc.data());
          this.isLoading=false;
         }
        });
      });
      console.log(this.photos);
  },


}


</script>

<style lang="scss">
@import "../../styles/css/theme-default.css";
@import "../../styles/css/themify-icons.css";
@import "../../styles/_varriable.scss";
@import "../../styles/admin.scss";
@import "../../styles/_varriable.scss";
@import "../../styles/_responsive.scss";
@import "../../styles/_section_title.scss";
@import "../../styles/_mixins.scss";
@import "../../styles/_reset.scss";
 @import "../../styles/pages/_gallery.scss";



.main {
  text-align: left;
  position: relative;
  .section{
    margin: 30px 0px;
     .images{
    display: flex;
    .photo{
    width: 200px;
    height: 100px;
    padding: 10px;
    
  }

  }

  }
    .line{
    margin-top: 3rem;
    margin-bottom: 3rem;
    border-radius: 41%;
    border: 0;
    border-top: 3px solid hsl(0deg 0% 90% / 29%);
  }
  
  .single_gallery {
    overflow: hidden;

    .thumb {
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
        @include transform(scaleX(1));
        @include transition(.5s);
      }

      .image_hover {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: #0f262fb3;
        transform: translateX(-40%);
        opacity: 0;
        @include transition(.5s);

        a {
          position: absolute;
          left: 50%;
          height: 100%;
          @include transform(translate(-50%));
          font-size: 35px;
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          i{
             z-index: 99999;
            cursor: pointer;
            width: 32px;
            height: 32px;
            background-size: contain;
            margin: 5px 0;
            &.show{
            background: url('~@/assets../../img/icons/eye.png');
            }
            &.remove{
            background: url('~@/assets../../img/icons/delete.png'); 
            }
          }
          
        }
      }
    }

    &:hover {
      .image_hover {
        transform: translateX(0%);
        opacity: 1;
       
      }

      img {
        width: 100%;
        @include transform(scaleX(1.2));
      }
    }
  }
  
}
</style>